import {
    CONTRACTORS,
    EMPLOYEES,
    REPORTS,
    PAYROLL,
    TAXATION,
    PAYROLL_HISTORY,
    SETTINGS,
    SETTINGS_GENERAL,
    SETTINGS_MAPPING,
    SETTINGS_WORKPLACES,
    SETTINGS_LEAVES_POLICIES
} from '@core/router/app-states';
import { NavigationMenuItem } from './navigation-menu-item';

export const NAVIGATION_MENU_ITEMS: NavigationMenuItem[] = [
    {
        label: 'Navigation.Menu.Payroll',
        icon: 'money-bag',
        state: PAYROLL,
        exceptions: [PAYROLL_HISTORY]
    },
    {
        label: 'Navigation.Menu.Payroll.History',
        icon: 'history',
        state: PAYROLL_HISTORY
    },
    {
        label: 'Navigation.Menu.Employees',
        state: EMPLOYEES,
        icon: 'users-group-rounded'
    },
    {
        label: 'Navigation.Menu.Contractors',
        state: CONTRACTORS,
        icon: 'user-rounded'
    },
    {
        label: 'Navigation.Menu.Reports',
        state: REPORTS,
        icon: 'pie-chart'
    },
    {
        label: 'Navigation.Menu.Taxation',
        state: TAXATION,
        icon: 'document'
    },
    {
        label: 'Navigation.Menu.Settings',
        state: SETTINGS,
        icon: 'cog',
        items: [
            {
                label: 'Navigation.Menu.Settings.General',
                state: SETTINGS_GENERAL,
            },
            {
                label: 'Navigation.Menu.Settings.Workplaces',
                state: SETTINGS_WORKPLACES
            },
            {
                label: 'Navigation.Menu.Settings.Leave',
                state: SETTINGS_LEAVES_POLICIES
            },
            {
                label: 'Navigation.Menu.Settings.EmployeeMapping',
                state: SETTINGS_MAPPING
            }
        ]
    }
];
